import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-c7dfc7a4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "question-header"
};
var _hoisted_3 = {
  key: 0,
  class: "question-intro-video"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "视频描述：", -1);
});
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 2,
  class: "question-content"
};
var _hoisted_7 = {
  key: 3,
  class: "question-footer"
};
var _hoisted_8 = {
  style: {
    "margin-left": "2px"
  }
};
var _hoisted_9 = {
  key: 4,
  class: "question-answer-container"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "参考答案：略", -1);
});
var _hoisted_11 = [_hoisted_10];
var _hoisted_12 = {
  key: 5,
  class: "mark-record-container"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "title"
  }, "阅卷信息", -1);
});
var _hoisted_14 = {
  class: "answer-table-box"
};
var _hoisted_15 = {
  class: "answer-table"
};
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("th", null, "评分标准", -1);
});
var _hoisted_18 = {
  class: "hl"
};
var _hoisted_19 = {
  key: 0
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("th", null, "总分", -1);
});
var _hoisted_21 = {
  class: "hl"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CustomAudio = _resolveComponent("CustomAudio");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_space = _resolveComponent("a-space");
  var _component_Image = _resolveComponent("Image");
  var _component_EditOutlined = _resolveComponent("EditOutlined");
  var _component_EyeOutlined = _resolveComponent("EyeOutlined");
  var _component_ClockCircleOutlined = _resolveComponent("ClockCircleOutlined");
  var _component_a_popover = _resolveComponent("a-popover");
  var _component_VideoDialog = _resolveComponent("VideoDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.question.audioUrl ? (_openBlock(), _createBlock(_component_CustomAudio, {
    key: 0,
    audioUrl: _ctx.question.audioUrl
  }, null, 8, ["audioUrl"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.question.title), 1)]), _ctx.contentVideoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_space, null, {
    default: _withCtx(function () {
      return [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentVideoList, function (item, i) {
        return _openBlock(), _createBlock(_component_a_button, {
          key: i,
          type: "link",
          onClick: function ($event) {
            return _ctx.showVideoIntro(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.question.content || _ctx.question.description ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "question-content",
    innerHTML: _ctx.question.content || _ctx.question.description
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _ctx.question.contentPic ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Image, {
    src: _ctx.question.contentPic,
    alt: "question content image"
  }, null, 8, ["src"])])) : _createCommentVNode("", true), !_ctx.hidePreview ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_button, {
    type: "primary",
    onClick: _ctx.showIde,
    shape: "round",
    size: "large"
  }, {
    default: _withCtx(function () {
      return [_ctx.question.questionStatus === 'completed' ? (_openBlock(), _createBlock(_component_EditOutlined, {
        key: 0
      })) : (_openBlock(), _createBlock(_component_EyeOutlined, {
        key: 1
      })), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.answerMode ? '预览' : _ctx.question.questionStatus === 'completed' ? '去修改' : '开始答题'), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.answerMode && _ctx.hasPaperAnswer ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), _ctx.answerMode && _ctx.markRecordData ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("table", _hoisted_15, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_ctx.markRecordData.markRuleNameData && _ctx.markRecordData.markRuleNameData.length ? (_openBlock(), _createElementBlock("th", _hoisted_16)) : _createCommentVNode("", true), _hoisted_17, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, function (item) {
    return _openBlock(), _createElementBlock("th", {
      key: item.id
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createVNode(_component_a_popover, {
      overlayClassName: "popover-round"
    }, {
      content: _withCtx(function () {
        return [_createElementVNode("span", null, "阅卷时间：" + _toDisplayString(_ctx.formatDateToSecond(item.start)) + "-" + _toDisplayString(_ctx.formatDateToSecond(item.end)), 1)];
      }),
      default: _withCtx(function () {
        return [_createVNode(_component_ClockCircleOutlined, {
          style: {
            "color": "#8f96a3",
            "font-size": "14px",
            "margin-left": "5px"
          }
        })];
      }),
      _: 2
    }, 1024)]);
  }), 128))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.markRuleNameData, function (rule, ruleIndex) {
    return _openBlock(), _createElementBlock("tr", null, [_createElementVNode("td", null, _toDisplayString(ruleIndex + 1), 1), _createElementVNode("td", null, _toDisplayString(rule), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, function (item) {
      return _openBlock(), _createElementBlock("td", {
        key: item.id
      }, [_createElementVNode("span", null, _toDisplayString(item[ruleIndex].markScore), 1), _createElementVNode("span", _hoisted_18, "/" + _toDisplayString(item[ruleIndex].ruleScore) + "分", 1)]);
    }), 128))]);
  }), 256))]), _createElementVNode("tfoot", null, [_createElementVNode("tr", null, [_ctx.markRecordData.markRuleNameData && _ctx.markRecordData.markRuleNameData.length ? (_openBlock(), _createElementBlock("th", _hoisted_19)) : _createCommentVNode("", true), _hoisted_20, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, function (item) {
    return _openBlock(), _createElementBlock("th", {
      key: item.id
    }, [_createElementVNode("span", null, _toDisplayString(item.totalScore), 1), _createElementVNode("span", _hoisted_21, "/" + _toDisplayString(item.totalPaperScore) + "分", 1)]);
  }), 128))])])])])])) : _createCommentVNode("", true), _createVNode(_component_VideoDialog, {
    config: _ctx.introVideoConf
  }, null, 8, ["config"])]);
}